<template>
  <div class="fieldset-prefectures-parts">
    <label for="fieldset-prefectures">
      <span class="label-text">{{ $t('formParts.label.prefectures') }}</span>
      <span class="required" v-if="required">{{ $t('formParts.required') }}</span>
    </label>
    <atom-input-select-object
      class="login-inputs-parts__country-field"
      id="fieldset-prefectures"
      :placeholder="$t('formParts.placeholder.prefectures')"
      v-model="prefectures"
      :error="showError"
      :options="prefecturesData"
      @enter="emitEnter"
    />

    <form-error-message-parts
      :showError="showError"
      :message="errorMessage !== '' ? errorMessage : $t('formParts.errorMessage.prefectures')"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import Const from '@/util/Const'
import AtomInputSelectObject from '@/components/atoms/input/AtomInputSelectObject.vue'
import FormErrorMessageParts from '@/components/common/form/FormErrorMessageParts.vue'
import { Multilingual } from '@/store/stores/collectionModule/documents/GeneralTypes'

interface prefecturesType {
  name: Multilingual
  id: string
}

export type DataType = {
  prefecturesData: Array<prefecturesType>
}

/**
 * フィールドセット お住まいの都道府県入力 バーツ
 * todo: 選択肢取得・多言語対応？
 */
export default defineComponent({
  name: 'FieldsetPrefecturesParts',
  components: {
    AtomInputSelectObject,
    FormErrorMessageParts,
  },
  props: {
    /**
     * 入力データ
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * 必須フラグ
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーフラグ
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーメッセージ
     */
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data(): DataType {
    return {
      /**
       * 都道府県リスト
       */
      prefecturesData: Const.USER_PREFECTURES_LIST,
    }
  },
  setup(props, context) {
    /**
     * prefectures
     * @param {string} val 都道府県
     */
    const prefectures = computed({
      get: () => props.value,
      set: (val: string) => context.emit('input', val),
    })
    return {
      prefectures,
    }
  },
  methods: {
    /**
     * エンターキーが押されたことを通知する
     */
    emitEnter() {
      /**
       * エンターキーが押されたことを通知する
       * @event enter
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
</script>

<style lang="scss" scoped>
.fieldset-prefectures-parts {
  @include fieldSet();
}
</style>
